import 'slick-carousel'

$(function() {
  $('.js-visualSlider').slick({
    fade: true,
    autoplay: true,
    autoplaySpeed: 4000,
    dots: true,
    arrows: false,
    pauseOnHover: false,
  });
});